import React from 'react';
import type { Control } from 'react-hook-form';

import Checkbox from '@components/uikit/Checkbox/Checkbox';

import useTranslation from '@hooks/useTranslation';

import { useActionItemMetaInfoQuery } from '@services/useActionItemMetaInfoQuery';
import { useUserEmailEventDictionaryQuery } from '@services/user/useUserEmailEventDictionaryQuery';

import { PROFILE_FIELDS } from '../../constants/schemaProfile';
import AdditionalInfoSkeleton from './AdditionalInfoSkeleton';
import style from './style.module.scss';

interface IProps {
  isLoading: boolean;
  control: Control<any>;
  allFacilities?: number;
}

const AdditionalInfo: React.FC<IProps> = ({ isLoading, control, allFacilities }) => {
  const { t } = useTranslation();

  const { data: aiMetaInfoData } = useActionItemMetaInfoQuery();

  const urgenciesList = aiMetaInfoData?.actionListUrgencies.list || [];

  const { data: emailEventsData } = useUserEmailEventDictionaryQuery();

  return (
    <div className={style.additionalInfo}>
      <div>
        <div className={style.blockTitle}>{t('Additional email notification')}</div>
        {isLoading ? (
          <AdditionalInfoSkeleton />
        ) : (
          <div className={style.blockContainer}>
            {emailEventsData?.additionalEmailEventsList.map((event) => (
              <Checkbox
                key={event.id}
                name={`${PROFILE_FIELDS.SIMPLE_EMAIL_SUBSCRIPTIONS}[${event.id}]`}
                control={control}
                label={t(event.name)}
                withHelperText={false}
              />
            ))}
            {!!allFacilities && (
              <Checkbox
                name={PROFILE_FIELDS.DEFAULT_SUBSCRIBED}
                control={control}
                label={t('Automatically subscribe to email alerts for new facilities')}
                withHelperText={false}
              />
            )}
            <Checkbox
              name={PROFILE_FIELDS.RECEIVE_OWN_EMAILS}
              control={control}
              label={t('Send me emails for comments and reports that I submit')}
              withHelperText={false}
            />
          </div>
        )}
      </div>
      <div>
        <div className={style.blockTitle}>{t('Mobile App Notifications')}</div>
        {isLoading ? (
          <AdditionalInfoSkeleton />
        ) : (
          <div className={style.blockContainer}>
            {!!urgenciesList.length &&
              urgenciesList.map((urgency) => (
                <Checkbox
                  key={urgency.name}
                  className={style[`checkbox${urgency.name}`]}
                  name={`${PROFILE_FIELDS.ACTION_LIST_URGENCIES}[${urgency.id}]`}
                  control={control}
                  label={urgency.name || ''}
                  withHelperText={false}
                />
              ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default AdditionalInfo;
